import type { DiagramEditActionType } from "./edit.types";
import { useBusEmitterListener } from "../bridge";

const editInProgressEvent = Symbol("edit:editInProgress");
const editAppliedEvent = Symbol("edit:editApplied");
const outlineEditAppliedEvent = Symbol("edit:outlineEditApplied");

export interface Payload {
  isExternal: boolean;
  objectIds: string[];
  action: DiagramEditActionType;
  undoKey: string;
  isRollback: boolean;
}

export type EditInProgressPayload = Payload;
export type EditCommitPayload = Payload;
export type OutlineEditAppliedPayload = Payload;

export const {
  emitter: editInProgress,
  listener: onEditInProgress,
} = useBusEmitterListener<EditInProgressPayload>(editInProgressEvent);

export const {
  emitter: editApplied,
  listener: onEditApplied,
} = useBusEmitterListener<EditCommitPayload>(editAppliedEvent);

export const {
  emitter: outlineEditApplied,
  listener: onOutlineEditApplied,
} = useBusEmitterListener(outlineEditAppliedEvent);
